module.exports = __webpack_public_path__ + "static/media/Mouth_6.8209d66b.jpg";